import React, { useState, useEffect } from 'react'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules' // Import module Navigation
import 'swiper/swiper-bundle.css' // Import CSS của Swiper
import {
  getFromlocalstorage,
  getFromsessionstorage
} from '../../../../component/MaHoaDuLieu/MaHoaDuLieu'
import { getApiUrl } from '../../../../api/api'
import Loading from '../../../../component/Loading/Loading'
import './Casino.scss'
import Notify from '../../../../component/Notify/Notify'

const liveItems = [
  {
    id: 'AWC_S',
    name: 'Sexy',
    logo: '/casino/icon-awc_s.png',
    titleImg: '/casino/awc_s-title.png',
    picImg: '/casino/awc_s.png',
    goGameParam: ['AWC_S', 'AWC_S'],
    portfolio: 'SeamlessGame',
    gameproviderid: '7',
    gameid: '0'
  },
  {
    id: 'DG',
    name: 'DG',
    logo: '/casino/icon-dg.png',
    titleImg: '/laptop/menu/casino/icondg.png',
    picImg: '/laptop/menu/casino/dgitem.png',
    goGameParam: ['DG', 'DG'],
    portfolio: 'SeamlessGame',
    gameproviderid: '1030',
    gameid: '0'
  },
  {
    id: 'WM',
    name: 'WM',
    logo: '/casino/icon-wm.png',
    titleImg: '/laptop/menu/casino/iconwm.png',
    picImg: '/laptop/menu/casino/wmitem.png',
    goGameParam: ['WM', 'WM'],
    portfolio: 'SeamlessGame',
    gameproviderid: '0',
    gameid: '0'
  },
  {
    id: 'AG',
    name: 'AG',
    logo: '/casino/icon-agin.png',
    titleImg: '/laptop/menu/casino/iconag.png',
    picImg: '/laptop/menu/casino/agitem.png',
    goGameParam: ['AGIN', '0'],
    portfolio: 'SeamlessGame',
    gameproviderid: '1035',
    gameid: '0'
  },
  {
    id: 'EVO',
    name: 'Evo Live',
    logo: '/casino/icon-evo.png',
    titleImg: '/laptop/menu/casino/iconevo.png',
    picImg: '/laptop/menu/casino/evoitem.png',
    goGameParam: ['EVO', 'EVO'],
    portfolio: 'SeamlessGame',
    gameproviderid: '20',
    gameid: '0'
  },
  {
    id: 'SA',
    name: 'SA GAMING',
    logo: '/casino/icon-sa.png',
    titleImg: '/laptop/menu/casino/iconsa.png',
    picImg: '/laptop/menu/casino/saitem.png',
    goGameParam: ['SA', 'SA'],
    portfolio: 'SeamlessGame',
    gameproviderid: '19',
    gameid: '0'
  }
]

const Casino = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [isLoading, setisLoading] = useState(false)
  const dangnhap = localStorage.getItem('dangnhap')
  const [notiMessage, setNotiMessage] = useState('')

  const device = window.innerWidth > 540 ? 'd' : 'm'
  const userdata =
    JSON.parse(getFromsessionstorage('data_u')) ||
    JSON.parse(getFromlocalstorage('data_u'))

  const hanldePostWidthdraw = async (portfolio, gameProviderId, gameId) => {
    try {
      setisLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/launch_game`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          portfolio,
          device,
          gameProviderId,
          gameId,
          userData: userdata,
          productId: null
        })
      })
      const data = await response.json()
      console.log(data)

      if (data.message) {
        setisLoading(false)
        alert(data.message)
      } else {
        if (data.url) {
          window.location.href = data.url
          setisLoading(false)
        }
      }
    } catch (error) {
      setisLoading(false)
      console.error('Failed to fetch API: ', error)
    }
  }

  useEffect(() => {
    const swiper = new Swiper('.swiper-container', {
      modules: [Navigation], // Kích hoạt module Navigation
      slidesPerView: 'auto', // Cho phép slide có chiều rộng tự nhiên
      spaceBetween: 3, // Khoảng cách giữa các slide
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    })

    return () => swiper.destroy(true, true) // Dọn dẹp khi component unmount
  }, [])

  const handleTabClick = index => {
    setActiveIndex(index)
  }

  return (
    <>
      {notiMessage && (
        <Notify
          message={notiMessage}
          setcontent={setNotiMessage}
          type='error'
        />
      )}

      <div className='live-box'>
        <Loading isLoading={isLoading} />
        <div className='container wrap'>
          <div id='liveList' className='live-game tab tab-slideshow'>
            <div className='tabframe'>
              <div
                className='swiper-button-prev'
                role='button'
                aria-label='Previous slide'
              ></div>
              <div className='swiper-container'>
                <div className='tab_ctrl ctrl swiper-wrapper'>
                  {liveItems.map((item, index) => (
                    <a
                      key={item.id}
                      className={`swiper-slide tab_btn ${
                        index === activeIndex ? 'active' : ''
                      }`}
                      href='#!'
                      onClick={() => handleTabClick(index)}
                    >
                      <img
                        src={item.logo}
                        alt={`${item.name}-logo`}
                        className='live-provider-logo-img'
                      />
                      <span className='name'>{item.name}</span>
                    </a>
                  ))}
                </div>
              </div>
              <div
                className='swiper-button-next'
                role='button'
                aria-label='Next slide'
              ></div>
            </div>
            <div className='tab_main main'>
              {liveItems.map((item, index) => (
                <div
                  key={item.id}
                  className={`tab_item item ${
                    index === activeIndex ? 'active' : ''
                  }`}
                  style={{ display: index === activeIndex ? 'flex' : 'none' }}
                >
                  <div className='content-box animated fadeInLeft'>
                    <img
                      src={item.titleImg}
                      alt={item.name}
                      className='live-provider-img'
                    />
                    <img
                      className='icon-pic'
                      src='/casino/icon-pic.png'
                      alt=''
                    />
                    <a
                      className='play-btn'
                      href='#!'
                      onClick={() => {
                        if (!dangnhap) {
                          setNotiMessage('Vui lòng đăng nhập để chơi game')
                        } else {
                          hanldePostWidthdraw(
                            item.portfolio,
                            item.gameproviderid,
                            item.gameid
                          )
                        }
                      }}
                    >
                      PLAY NOW
                    </a>
                  </div>
                  <div className='pic animated fadeInRight'>
                    <img src={item.picImg} alt={item.name} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Casino
